export const DROPDOWN_OFFSET_CONFIG = { crossAxis: 0, mainAxis: 0 }
